import { Overline, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface INewbuildingPremiumBuilderLogoProps {
  logoUrl?: string | null;
  builderName: string;
  url: string;
  onClick?: () => void;
}

export const PremiumBuilderLogo: React.FC<INewbuildingPremiumBuilderLogoProps> = ({
  logoUrl,
  builderName,
  url,
  onClick,
}) => {
  return (
    <div className={style['logo']}>
      <a data-testid="builder-logo-link" href={url} target="_blank" rel="noreferrer" onClick={onClick}>
        <div
          className={style['img']}
          style={logoUrl ? { backgroundImage: `url(${logoUrl})` } : { backgroundColor: `#f1f2f4` }}
        />

        <Overline>Застройщик</Overline>
        <UIHeading3 color="text-main-default">{builderName}</UIHeading3>
      </a>
    </div>
  );
};
